<template>
  <a
    href="#main-content"
    class="skip-link"
  >
    Preskočiť na hlavný obsah
  </a>
  <Header />
  <main
    id="main-content"
    class="w-100"
  >
    <slot name="page-header" />

    <ContainerFluid>
      <slot name="breadcrumbs" />
      <!-- WCAG 2.4.3: DOM order matches visual order (left to right) -->
      <div class="row mt-12 mb-12 mb-md-20 justify-content-between">
        <aside class="col-12 col-md-3 order-2 order-md-1">
          <slot name="aside" />
        </aside>
        <div
          class="col-12 col-md-9 col-lg-9 order-1 order-md-2 mb-10 mb-md-0"
        >
          <slot />
        </div>
      </div>
      <IconsWrapper>
        <IconsSymbolArrowLeft />
      </IconsWrapper>
    </ContainerFluid>
  </main>
  <LazyFooter />
  <div id="modal-wrap" />
</template>
